import React from 'react';
import cx from 'classnames';
import ReactFormControlLabel from '@material-ui/core/FormControlLabel';
import ReactRadio from '@material-ui/core/Radio';
import ReactRadioGroup from '@material-ui/core/RadioGroup';
import { FocusBox } from '../../theme/focus';
import * as componentStyling from '../styling';

export default function Radio({autoFocus, ...props}) {
	return (
		<ReactFormControlLabel {...props} control={<ReactRadio autoFocus={autoFocus}/>} />
	);
}

export const RadioGroup = React.memo(({options, autoFocus, ...props}) => {
	return (
		<FocusBox>
			{options ? (
				<ReactRadioGroup {...props} aria-label={props.label} >
					{options.map(({ value, label }, i) => (
						<Radio key={`option-${i}`} value={value} label={label} autoFocus={autoFocus && i===0} className={cx(componentStyling.Control)} />
					))}
				</ReactRadioGroup>
			) : (
				<ReactRadioGroup {...props} aria-label={props.label} />
			)}
			
		</FocusBox>
	);
});